import React from 'react'
import { ChatTemplateEditContainer } from '@/components/containers/chat-template-edit'
import { useTitle } from '@/hooks/use-title'
import SettingsIcon from '@material-ui/icons/Settings'

export const ChatTemplateEditPage: React.FC = (props) => {
  useTitle('設定 / チャットテンプレート', <SettingsIcon />)
  return <ChatTemplateEditContainer {...props} />
}
